import styled, { css } from 'styled-components'
import { bounceOutDown, bounceInUp } from 'react-animations'
import { media } from '../../../../utils'

export const Btn = styled.button`
  appearance: none;
  margin: 15px auto;
  padding: 15px;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;

  &:focus {
    outline: none;
  }
  &:hover {
    outline: none;
  }
`

export const ChangeBtn = styled.a`
  appearance: none;
  padding: 5px 15px;
  border: 1.5px solid #677d7f;
  border-radius: 0;
  color: ${props => props.status ? "#677d7f" : "#677d7f"};
  font-size: 15px;
  text-align: center;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.25s ease-in-out;

  &:hover {
    color: white;
    background-color: #974353;
    border-color: #974353;
  }
`
export const EditBtn = styled.a`
  appearance: none;
  display: flex;
  align-self: flex-end;
  width: 145px;
  padding: 5px 15px;
  border: 1.5px solid #677d7f;
  border-radius: 0;
  color: ${props => props.status ? "#677d7f" : "#677d7f50"};
  font-size: 15px;
  text-align: center;
  background-color: transparent;
  float: right;
  cursor: pointer;
  transition: all 0.25s ease-in-out;

  &:hover {
    color: white;
    background-color: #974353;
    border-color: #974353;
  }
`


export const RedBtn = styled(Btn)`
  min-width: 200px;
  color: white;
  box-shadow: 0px 5px 10px 0px #b4b4b4;
  ${(props) => (props.disabled ? 'background: #C6A3A9' : 'background: #974353')}
  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  }
`

export const LightBlueBtn = styled(Btn)`
  width: 100%;
  max-width: 230px;
  color: #9abbbf;
  background: white;
  border: 2px solid #9abbbf;
  &:hover {
    box-shadow: 0px 5px 10px 0px #b4b4b4;
    outline: none;
  }
`

export const StartBtn = styled.button`
  color: white;
  width: 12em;
  background: #974353;
  background: ${(props) => (props.disabled ? '#C6A3A9' : '#974353')};
  border: none;
  padding: 18px 20px;
  cursor: pointer;
  font-family: Montserrat;
  text-transform: uppercase;
  letter-spacing: 3px;
  box-shadow: 10px 10px 20px #888;

  font-size: 18px;
  font-weight: bold;

  height: 100%;

  ${(props) => props.centered && 'display: block; margin: auto;'}

  ${(props) =>
    props.isFocused
      ? css`
          animation: 1s ${bounceOutDown} ease forwards;
        `
      : css`
          animation: 1s ${bounceInUp} ease forwards;
        `}

  &:focus {
    outline: none;
  }
`

export const TranspBtn = styled.button`
  display: inline-block;
  height: 100%;
  margin: 0 10px;
  background: rgb(0, 0, 0, 0);
  border: none;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;

  ${media.desktop`font-size: 16px;`}
  ${media.tablet`
    font-size: 14px;
    height: 40px;
    margin: 5px;
    `}
  ${media.phone`font-size: 14px;`}
  &:focus {outline: none;}`



// WEBPACK FOOTER //
// ./src/components/atoms/input/buttons/index.tsx